import {Inject, Injectable, PLATFORM_ID} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {NEVER, Observable, of} from "rxjs";
import {JourneySettingResponse} from "fello-model";
import {FelloApiService, StateTransferResolver, UrlUtils} from "fello-common";
import {catchError, switchMap} from "rxjs/operators";
import {environment} from "../../../../environments/environment";
import {TransferState} from "@angular/platform-browser";
import {DOCUMENT, isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: "root"
})
export class JourneySettingsResponseResolver
  extends StateTransferResolver<JourneySettingResponse | null>
  implements Resolve<JourneySettingResponse | null>
{
  constructor(
    private felloApiService: FelloApiService,
    transferState: TransferState,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private _platformId: Object
  ) {
    super(transferState, _platformId);
  }

  resolve2(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<JourneySettingResponse | null> {
    const dashboardId = route.paramMap.get("journeyId")!;
    return this.felloApiService.getJourneySettings(dashboardId).pipe(catchError(err => of(null)));
  }

  protected transform(obs: Observable<JourneySettingResponse | null>): Observable<JourneySettingResponse | null> {
    return obs.pipe(
      switchMap(settings => {
        if (isPlatformBrowser(this._platformId) && settings?.subdomain && environment.enableSubdomainFixing) {
          const currentUrl = this.document.location.href;
          const updatedUrl = UrlUtils.updateSubdomain(currentUrl, settings.subdomain);
          if (updatedUrl !== currentUrl) {
            this.document.location.href = updatedUrl;
            return NEVER;
          }
        }
        return of(settings);
      })
    );
  }
}
